import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Linkedin } from "lucide-react";

export default function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section data-testid="final-cta-section" ref={ref} className="relative py-32 md:py-44 px-6 md:px-12 overflow-hidden">
      {/* Radial glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] md:w-[900px] md:h-[900px] rounded-full pointer-events-none" style={{ background: "radial-gradient(circle, rgba(0,229,255,0.06) 0%, rgba(123,94,167,0.03) 30%, transparent 60%)" }} />

      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 60, scale: 0.92 }}
          animate={isInView ? { opacity: 1, y: 0, scale: 1 } : {}}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="text-[#00E5FF] text-xs font-bold tracking-[0.35em] uppercase mb-6">El momento es ahora</p>
          <h2 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black tracking-tight text-white leading-[1.08] mb-6">
            No te quedes fuera de{" "}
            <span className="bg-gradient-to-r from-[#00E5FF] via-[#7B5EA7] to-[#F5A623] bg-clip-text text-transparent">la revolución.</span>
          </h2>
          <p className="text-[#6B7FD7] text-base md:text-lg max-w-xl mx-auto mb-12 leading-relaxed">
            Eminal Dynamics va a transformar cómo operan las PYMEs en España. Sé de los primeros en saberlo.
          </p>

          <motion.div className="relative inline-block">
            <div className="absolute inset-0 rounded-full border border-[#F5A623]/20" style={{ animation: "pulse-ring 2.5s ease-out infinite" }} />
            <div className="absolute inset-0 rounded-full border border-[#F5A623]/10" style={{ animation: "pulse-ring 2.5s ease-out infinite 0.7s" }} />
            <motion.a
              data-testid="final-linkedin-cta"
              href="https://www.linkedin.com/company/eminal-dynamics"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.06, boxShadow: "0 0 60px rgba(245,166,35,0.35)" }}
              whileTap={{ scale: 0.96 }}
              className="relative inline-flex items-center gap-3 px-10 py-4 rounded-full bg-gradient-to-r from-[#F5A623] to-[#E8941A] text-[#080C14] font-black text-base tracking-wide shadow-[0_0_35px_rgba(245,166,35,0.25)] hover:shadow-[0_0_60px_rgba(245,166,35,0.4)] transition-shadow duration-300"
            >
              <Linkedin className="w-5 h-5" />
              Síguenos en LinkedIn
            </motion.a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
